var map = {
	"./auth-modules/login/login.module": [
		"../../../../../src/app/auth-modules/login/login.module.ts",
		"login.module"
	],
	"./auth-modules/reset-password/reset-password.module": [
		"../../../../../src/app/auth-modules/reset-password/reset-password.module.ts",
		"reset-password.module"
	],
	"./course-building/course-building.module": [
		"../../../../../src/app/layout/modules/teacher/courses/course-building/course-building.module.ts",
		"course-building.module",
		"common"
	],
	"./courses/courses.module": [
		"../../../../../src/app/layout/modules/teacher/courses/courses.module.ts",
		"courses.module",
		"common"
	],
	"./document-submission/document-submission.module": [
		"../../../../../src/app/layout/modules/teacher/document-submission/document-submission.module.ts",
		"common",
		"document-submission.module"
	],
	"./elective-and-seminar-building/elective-and-seminar-building.module": [
		"../../../../../src/app/layout/modules/teacher/elective-and-seminar/elective-and-seminar-building/elective-and-seminar-building.module.ts",
		"elective-and-seminar-building.module",
		"common"
	],
	"./elective-and-seminar/elective-and-seminar.module": [
		"../../../../../src/app/layout/modules/teacher/elective-and-seminar/elective-and-seminar.module.ts",
		"common",
		"elective-and-seminar.module"
	],
	"./folder/folder.module": [
		"../../../../../src/app/layout/modules/teacher/courses/folder/folder.module.ts",
		"common",
		"folder.module"
	],
	"./inbox/inbox.module": [
		"../../../../../src/app/layout/modules/teacher/inbox/inbox.module.ts",
		"common",
		"inbox.module"
	],
	"./layout/layout.module": [
		"../../../../../src/app/layout/layout.module.ts",
		"layout.module"
	],
	"./modules/teacher/teacher.module": [
		"../../../../../src/app/layout/modules/teacher/teacher.module.ts",
		"teacher.module",
		"common"
	],
	"./peer-group/peer-group.module": [
		"../../../../../src/app/layout/modules/teacher/courses/peer-group/peer-group.module.ts",
		"common",
		"peer-group.module"
	],
	"./search/search.module": [
		"../../../../../src/app/layout/modules/teacher/search/search.module.ts",
		"common",
		"search.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// G:/UTL/Teacher/Teacher-ANG/src/$$_lazy_route_resource lazy
// module id = ../../../../../src/$$_lazy_route_resource lazy recursive
// module chunks = main